import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React from "react";
import {MailMetaDataDescription} from "../../models/MailMetaDataDescription";

interface IRelationshipDescriptionProps {
	metadata: Partial<MailMetaDataDescription>;
}

export const RelationshipDescription: React.FC<IRelationshipDescriptionProps> = (props) => {
	return <div><Grid container spacing={2}>
		<Grid item xs={12}>
			<Typography variant="h6">Related Email Address:</Typography>
			<Typography>{props.metadata.relatedEmailAddress}</Typography>
		</Grid>
		<Grid item xs={12} sm={6}>
			<Typography variant="h6">Relationship Number:</Typography>
			<Typography>{props.metadata.relationshipNumber}</Typography>
		</Grid>
		<Grid item xs={12} sm={6}>
			<Typography variant="h6">Initials:</Typography>
			<Typography>{props.metadata.initials}</Typography>
		</Grid>
		<Grid item xs={12}>
			<Typography variant="h6">Name:</Typography>
			<Typography>{props.metadata.name}</Typography>
		</Grid>
		<Grid item xs={12}>
			<Typography variant="h6">Titles:</Typography>
			<Typography>{props.metadata.titles}</Typography>
		</Grid>
		<Grid item xs={12}>
			<Typography variant="h6">Agent Name:</Typography>
			<Typography>{props.metadata.agentName}</Typography>
		</Grid>
		<Grid item xs={12}>
			<Typography variant="h6">Agent Email Address:</Typography>
			<Typography>{props.metadata.agentEmailAddress}</Typography>
		</Grid>
		<Grid item xs={12}>
			<Typography variant="h6">Street:</Typography>
			<Typography>{props.metadata.street}</Typography>
		</Grid>
		<Grid item xs={12} sm={6}>
			<Typography variant="h6">House Number:</Typography>
			<Typography>{props.metadata.houseNumber}</Typography>
		</Grid>
		<Grid item xs={12} sm={6}>
			<Typography variant="h6">House Number Addition:</Typography>
			<Typography>{props.metadata.houseNumberAddition}</Typography>
		</Grid>
		<Grid item xs={12} sm={6}>
			<Typography variant="h6">Postcode:</Typography>
			<Typography>{props.metadata.postcode}</Typography>
		</Grid>
		<Grid item xs={12} sm={6}>
			<Typography variant="h6">City:</Typography>
			<Typography>{props.metadata.city}</Typography>
		</Grid>
		<Grid item xs={12}>
			<Typography variant="h6">Country:</Typography>
			<Typography>{props.metadata.country}</Typography>
		</Grid>
		<Grid item xs={12}>
			<Typography variant="h6">Post Street:</Typography>
			<Typography>{props.metadata.postStreet}</Typography>
		</Grid>
		<Grid item xs={12} sm={6}>
			<Typography variant="h6">Post House Number:</Typography>
			<Typography>{props.metadata.postHouseNumber}</Typography>
		</Grid>
		<Grid item xs={12} sm={6}>
			<Typography variant="h6">Post House Number Addition:</Typography>
			<Typography>{props.metadata.postHouseNumberAddition}</Typography>
		</Grid>
		<Grid item xs={12} sm={6}>
			<Typography variant="h6">Post Postcode:</Typography>
			<Typography>{props.metadata.postPostcode}</Typography>
		</Grid>
		<Grid item xs={12} sm={6}>
			<Typography variant="h6">Post City:</Typography>
			<Typography>{props.metadata.postCity}</Typography>
		</Grid>
		<Grid item xs={12}>
			<Typography variant="h6">Post Country:</Typography>
			<Typography>{props.metadata.postCountry}</Typography></Grid></Grid></div>;
};
